import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { EvalPlaygroundHistory } from '@/features/admin/eval-playground/history'

const historySearchSchema = z.object({
  page: z.number().optional().catch(1),
  jobId: z.string().optional(),
})

export const Route = createFileRoute(
  '/_authenticated/admin/eval-playground/history'
)({
  validateSearch: historySearchSchema,
  component: EvalPlaygroundHistory,
})
